import { useEffect, useRef } from "react";

/**
 * Jun/2026: "trampa" del botón/gesto atrás (Android: deslizar desde el borde).
 * Mientras `active`, el gesto atrás NO navega: dispara `onBack` para que el
 * componente decida (preguntar si guardar, cerrar, etc.).
 */
export function useBackTrap(active, onBack) {
  const cb = useRef(onBack);
  cb.current = onBack;
  useEffect(() => {
    if (!active) return undefined;
    const marker = { beemTrap: Date.now() };
    window.history.pushState(marker, "");
    const onPop = () => {
      window.history.pushState(marker, "");
      cb.current?.();
    };
    window.addEventListener("popstate", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
      // Nota: no hacemos history.back() aquí: con StrictMode / navegaciones
      // concurrentes el popstate resultante cerraba el pedido recién abierto.
    };
  }, [active]);
}

/** Aviso del navegador al recargar/cerrar pestaña con cambios sin guardar. */
export function useBeforeUnloadGuard(active) {
  useEffect(() => {
    if (!active) return undefined;
    const h = (e) => { e.preventDefault(); e.returnValue = ""; };
    window.addEventListener("beforeunload", h);
    return () => window.removeEventListener("beforeunload", h);
  }, [active]);
}
